import { SimpleForm, Create, FileInput, FileField, TextInput, CreateProps, required, useNotify } from "react-admin";
import { createUserIdentification } from ".";

const validateRequired = [required('مقدار را وارد کنید')];

export const UserIdentificationCreate = (props: CreateProps): React.ReactElement => {
    const notify = useNotify();

    const save = async (data: any) => {
        try {  
          const response = await createUserIdentification({data});  
          if (response && response.data) { 
            notify("درخواست ساخت لینک اختصاصی با موفقیت ثبت شد", { type: 'success' })
    
          } else {
            notify("درخواست ساخت لینک اختصاصی با خطا روبرو شد!", { type: 'error' })
          }
    
        } catch (error:any) { 
            console.error('err in UserIdentificationCreate: ', error)
            notify("درخواست ساخت لینک اختصاصی با خطا روبرو شد!", { type: 'error' })
        }
    
        window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/UserIdentificationLinkExcel`;
    
      };

    return (
        <Create {...props}>
            <SimpleForm style={{ direction: 'rtl' }} save={save}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
                    <FileInput validate={validateRequired} isRequired className="partner-upload-file" fullWidth accept=".csv" labelSingle="برای آپلود فایل csv کلیک کنید" source="attachment">
                        <FileField source="src" title="title" />
                    </FileInput>                
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
                    <TextInput type="date" validate={validateRequired} isRequired style={{width: '100%'}} source="expirationDate" label="تاریخ انقضا" />                                       
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
                    <TextInput style={{width: '100%'}} source="utmCampaign" label="کمپین" />
                    <TextInput style={{width: '100%'}} source="utmMedium" label="مدیوم" />
                    <TextInput style={{width: '100%'}} source="utmSource" label="سورس" />
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
                    <TextInput validate={validateRequired} isRequired style={{width: '100%'}} source="targetPageAddress" label="لینک صفحه هدف" />
                </div>
            </SimpleForm>
        </Create>
    )
}